import { path, prop } from 'ramda';
import { urls } from '../config';
import withAxios from '../utils/with-axios';
import brandings from './brandings';
import giftwraps from './giftwraps';

/**
 * Deprecated: return legacy themes by clientId
 */
function allByClientId($axios, clientId) {
  if (!clientId) {
    throw new Error('Prop `clientId` is required in `themes.allByClientId`.');
  }
  return $axios.get(urls.apiV2("/clients/".concat(clientId, "/themes"))).then(prop('data'));
}
function getById($axios, id) {
  if (!id) {
    throw new Error('Prop `id` is required in `themes.getById`.');
  }
  return $axios.get(urls.apiV3("/themes/".concat(id))).then(path(['data', 'data']));
}
function upsertModelTheme($axios, _ref) {
  var brandingId = _ref.brandingId,
    giftwrapId = _ref.giftwrapId;
  if (!brandingId && !giftwrapId) {
    throw new Error('At least one of prop `brandingId` and `giftwrapId` is required in `themes.upsertModelTheme`.');
  }
  return $axios.post(urls.apiV3('/themes/model/upsert'), {
    brandingId: brandingId,
    giftwrapId: giftwrapId
  }).then(path(['data', 'data']));
}
export default {
  allByClientId: withAxios(allByClientId),
  getById: withAxios(getById),
  upsertModelTheme: withAxios(upsertModelTheme),
  brandings: brandings,
  giftwraps: giftwraps
};